import React from 'react'

const OilRecordList = (props) => {
  return (
    <React.Fragment>{props.children}</React.Fragment>
  )
}

export default OilRecordList